import { render } from "./EstadoSolicitud.vue?vue&type=template&id=5c9c21b1"
import script from "./EstadoSolicitud.vue?vue&type=script&lang=js"
export * from "./EstadoSolicitud.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__